<template>
  <div class="teacher-time-serve">
    <Title :title="serveTitle" :english-title="serveEnglishTitle"></Title>
    <SortServe :showPublic="config.SHOW_PUBLIC_SERVE" :serve-url="serveUrl" :request="request" effect="light"></SortServe>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import Title from '../components/Title';

  export default {
    name: 'TimeServe',
    data() {
      return {
        serveTitle: '日常工作',
        serveEnglishTitle: 'daily work'
      };
    },
    components: {
      Title,
    },
    computed: {
      ...mapGetters([
        'serveUrl',
        'token',
        'request',
        "config"
      ]),
    },
  };
</script>
<style lang="scss">
  @import "@/styles/variables.scss";

  .teacher-time-serve {
    position: relative;
    display: flex;
    flex-direction: column;
    //justify-content: center;
    min-height: calc(100vh - 60px);
    background-color: rgba(255, 255, 255, 1);
    @include contentMedia

    .components-title {
      padding-top: 50px;
      padding-bottom: 50px;
    }

    .SortServe {
      width: 100%;
      margin-bottom: 20vh;

      .SortServe-trip-item {
        width: 130px;
        height: auto;

        .SortServe-trip-line {
          left: 0;
          right: 0;
        }
      }

      .SortServe-app {
        width: 100%;
      }
    }
  }
</style>
